export async function getFilterOptions() {
  const res = await window.axios({
    method: 'GET',
    baseURL: process.env.VUE_APP_EPRES_ENDPOINT,
    url: 'admin/prescription/filter-options',
  });
  return res.data.data.options;
}
